import React, { useEffect, useState } from 'react';

// We have to include all libraries that are used throughout Connect because we do not reload the map api
// between page loads (due to using turbo)
const LIBRARIES = ['drawing', 'places', 'marker'];

export default function MapScriptLoader({ children }: { children: React.ReactNode }) {
  const [librariesLoaded, setLibrariesLoaded] = useState(false);

  useEffect(() => {
    Promise.all(
      LIBRARIES.map(library => google.maps.importLibrary(library))
    ).then(() => {
      setLibrariesLoaded(true);
    });
  }, []);


  if (librariesLoaded) {
    return (
      <>
        {children}
      </>
    );
  } else {
    return null;
  }
}
